export default function formatCycleDuration(years, months) {
  if (!years && !months) {
    return null;
  }
  if (years && !months) {
    const yearStr = years === 1 ? '1 ano' : `${years} anos`;
    return yearStr;
  }
  if (!years && months) {
    const monthStr = months === 1 ? '1 mês' : `${months} meses`;
    return monthStr;
  }
  const yearStr = years === 1 ? '1 ano' : `${years} anos`;
  const monthStr = months === 1 ? '1 mês' : `${months} meses`;
  return `${yearStr} e ${monthStr}`;
}
